export interface IDeferredPromise<T = never, E = never> extends Promise<T> {
    resolve: (value?: T) => T | PromiseLike<T>;
    reject: (reason: any) => E | PromiseLike<E>;
}
// Promise that can be resolved/rejected later with dynamic arguments
export const deferredPromise = <T = never, E = never>(): IDeferredPromise<T, E> => {
    let resolveHandle, rejectHandle;

    const uncastedPromise = new Promise<T>((resolve, reject) => {
        resolveHandle = resolve;
        rejectHandle = reject;
    });

    // Cast to IDeferredPromise<T, E>
    const promise = uncastedPromise as IDeferredPromise<T, E>;
    promise.resolve = resolveHandle;
    promise.reject = rejectHandle;

    return promise;
};
